import Metrics from 'services/metrics';

export const EVENTS = {
  TV: 'TV',
};

export const CATEGORY = {
  TV_PLAYER: 'reproductor tv',
};

export const ACTIONS = {
  CLICK: 'click',
};

const availabilityOptions = {
  susc: 'por suscripcion',
  free: 'gratuito',
  ppe: 'alquiler',
  est: '',
};

const getCaterory = genres => {
  let category = '';
  if (genres) {
    for (let i of genres) {
      category += i?.name + ' ';
    }
    return category;
  }
  return '';
};

export const setEventToLivePlayerAnalyticsG4 = (
  evento,
  data,
  idioma,
  progress,
) => {
  const extendedcommon = data?.group?.common?.extendedcommon;
  const addon = extendedcommon?.media?.proveedor?.codigo;
  const genres = extendedcommon?.genres?.genre;
  const sell_type = extendedcommon?.format?.sell_type;
  const common = data?.group?.common;

  let category = '';
  let availability = '';

  category = getCaterory(genres);
  availability = availabilityOptions?.[sell_type] || '';

  const eventInfo = {
    event: evento,
    content_id: common?.id,
    content_name: common?.title,
    content_category: category,
    content_availability: `${availability} ${addon}`,
  };

  const tcdataLayerBaseTv = {
    ...eventInfo,
    content_episode: `no aplica`,
    content_list: `no aplica`,
    content_type: 'canal tv',
  };

  if (evento && data && idioma && !progress) {
    Metrics.newEvent({
      ...tcdataLayerBaseTv,
      interaction_type: idioma,
    });
    return;
  }
  if (evento && data && idioma && progress) {
    Metrics.newEvent({
      ...tcdataLayerBaseTv,
      progress_percentage: `${progress}%`,
    });
    return;
  }
  Metrics.newEvent(tcdataLayerBaseTv);
};
